import { LucideIcon } from 'lucide-react';
import { Link } from 'react-router';
import { useEffect } from 'react';
import confetti from 'canvas-confetti';

interface StatusPageProps {
  title: string;
  description: string;
  actions?: { label: string; url: string }[];
  icon: LucideIcon;
  color?: 'red' | 'yellow' | 'green';
  children?: React.ReactNode;
  effect?: 'confetti';
}

const colorClasses = {
  red: 'text-red',
  yellow: 'text-yellow',
  green: 'text-green',
};

export function StatusPage({
  title,
  description,
  actions = [],
  icon,
  color = 'green',
  children,
  effect,
}: StatusPageProps) {
  const Icon = icon;
  const colorClass = colorClasses[color];

  useEffect(() => {
    if (effect === 'confetti') {
      confetti({
        particleCount: 100,
        spread: 70,
        origin: { y: 0.6 },
      });
    }
  }, [effect]);

  return (
    <div className="flex flex-col items-center justify-center h-full gap-6 p-4">
      <Icon className={`w-20 h-20 ${colorClass}`} />
      <div className="flex flex-col items-center justify-center gap-2">
        <div className="text-4xl font-bold text-center">{title}</div>
        <div className="text-xl text-muted-foreground font-light text-center">{description}</div>
      </div>
      {actions.length > 0 && (
        <div className="flex flex-row gap-2">
          {actions.map((action) => (
            <Link key={action.label} to={action.url}>
              {action.label}
            </Link>
          ))}
        </div>
      )}
      {children}
    </div>
  );
}
